import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addTimezone,
  deleteTimezone,
  getTimezones,
  updateTimezone,
} from "store/services/dataManagement/timezone";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

// Get All Timezones
export const GetAllTimezonesAction = createAsyncThunk(
  "timezone/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getTimezones(payload);
      if (res.status === 1) return fulfillWithValue(res);
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Delete Timezone
export const DeleteTimezoneAction = createAsyncThunk(
  "timezone/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, onError, ...rest } = payload;
      const res = await deleteTimezone(rest);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        const responce = await getTimezones(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// Update Timezone
export const UpdateTimezoneAction = createAsyncThunk(
  "timezone/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateTimezone(rest);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);

// Add Timezone
export const AddTimezoneAction = createAsyncThunk(
  "timezone/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      const res = await addTimezone(rest);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);
